import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const FooterFormDates = ({ object }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }} p={1}>
      <Typography variant="caption">
        {`Created at ${new Date(
          Date.parse(object.created_at),
        ).toLocaleDateString()}`}
      </Typography>
      <Typography variant="caption">{`Id : ${object.id || "new"}`}</Typography>
      <Typography variant="caption">
        {`Updated at ${new Date(
          Date.parse(object.updated_at),
        ).toLocaleDateString()}`}
      </Typography>
    </Box>
  );
};

export default FooterFormDates;
